import { Input } from "modules/common";
import { UseFormReturn } from "modules/common/hooks/useForm";
import { AddressForm, AddressFormData } from "../AddressForm";

export interface CitizenFormData extends AddressFormData {
    oib: string;
    firstName: string;
    lastName: string;
}

interface Props {
    isLoading: boolean;
    form: UseFormReturn<CitizenFormData>;
    isOibReadOnly?: boolean;
    isFirstNameReadOnly?: boolean;
    isLastNameReadOnly?: boolean;
}

export const CitizenForm = ({ isLoading, form, isOibReadOnly, isFirstNameReadOnly, isLastNameReadOnly }: Props) => {
    const { labelFor, inputPropsFor } = form;

    return (
        <>
            {labelFor("oib", "OIB")}
            <Input isDisabled={isLoading || isOibReadOnly} placeholder="12345678903" {...inputPropsFor("oib")} />

            {labelFor("firstName", "Ime")}
            <Input isDisabled={isLoading || isFirstNameReadOnly} placeholder="Ivan" {...inputPropsFor("firstName")} />

            {labelFor("lastName", "Prezime")}
            <Input isDisabled={isLoading || isLastNameReadOnly} placeholder="Horvat" {...inputPropsFor("lastName")} />

            <AddressForm form={form} />
        </>
    );
};
